export const getParentPath = (id: string) => {
  const type = id.endsWith("/") ? "directory" : "file";
  const splitPath = (type === "directory" ? id.slice(0, -1) : id).split("/");
  if (splitPath.length === 1) {
    return "";
  } else {
    return splitPath.slice(0, -1).join("/") + "/";
  }
};

export const getAllParentPaths = (path: string): string[] => {
  const parentPaths: string[] = [];
  let currentPath = path;
  while (currentPath) {
    currentPath = getParentPath(currentPath);
    parentPaths.push(currentPath);
  }
  return parentPaths;
};
